export default __webpack_public_path__ + "static/media/transfer-old-bibly-1.06a697dc.png";